import React from 'react';
import { useTableInstance } from '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import { Paginator } from './Paginator.esm.js';

/**
 * Renders controls for navigating between pages of the table.
 *
 * Pass `enablePagination` to the `TableProvider` to activate.
 *
 * The `pageSize` and `pageIndex` values can be initialized by passing them via `initialState` to the `TableProvider`.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ConnectedPaginator, ConnectedTable, Paginator, TableProvider } from "@panwds/react-table";
 * ```
 */
const ConnectedPaginator = ({ menuStyle, pageSizeOptions = [10, 25, 50, 100], rowName, pageLabel, firstPageLabel, lastPageLabel, previousPageLabel, nextPageLabel, dataTestId, paginationType = 'standard' }) => {
    const { canPreviousPage, canNextPage, gotoPage, pageCount, pageOptions, previousPage, nextPage, setPageSize, state: { pageIndex, pageSize } } = useTableInstance();
    return (React.createElement(Paginator, { menuStyle: menuStyle, rowName: rowName, canPreviousPage: canPreviousPage, canNextPage: canNextPage, pageLabel: pageLabel, firstPageLabel: firstPageLabel, lastPageLabel: lastPageLabel, previousPageLabel: previousPageLabel, nextPageLabel: nextPageLabel, pageCount: pageCount, pageIndex: pageIndex, pageOptions: pageOptions, pageSize: pageSize, pageSizeOptions: pageSizeOptions, onSelectPage: (pageIndex) => gotoPage(pageIndex), onNextPage: nextPage, onPreviousPage: previousPage, onFirstPage: () => gotoPage(0), onLastPage: () => gotoPage(pageCount - 1), onChangePageSize: (pageSize) => setPageSize(pageSize), paginationType: paginationType, dataTestId: dataTestId }));
};

export { ConnectedPaginator };
//# sourceMappingURL=ConnectedPaginator.esm.js.map
